import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-editable-input',
  templateUrl: './editable-input.component.html',
  styleUrls: ['./editable-input.component.scss'],
})
export class EditableInputComponent implements OnInit {
  @Input() type: 'text' | 'number' | 'email' | 'tel' | 'password' | 'zip' =
    'text';
  @Input() form: FormGroup;
  @Input() control: string;
  @Input() placeholder: string = '';
  @Input() readonly = false;
  @Output() changed = new EventEmitter<void>();
  @ViewChild('editingField', { static: false }) editingField: ElementRef;
  editing = false;
  inputType: 'text' | 'number' | 'email' | 'tel' | 'password' = 'text';

  ngOnInit() {
    switch (this.type) {
      case 'zip':
        this.inputType = 'text';
        break;
      default:
        this.inputType = this.type || 'text';
        break;
    }
  }

  toggleEdit() {
    if (this.editing) {
      this.changed.emit();
    }
    this.editing = !this.editing;
    if (this.editing) {
      // setTimeout(() => {
      //   this.editingField.nativeElement.focus();
      // }, 0);
    }
  }
}
